import * as React from 'react';
import * as _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import {ExtendedWrappedFieldProps} from '../FormFields';
import GridFormRow, {GridFormRowProp} from '../GridFormRow/GridFormRow';

function GridFormLabel<P extends ExtendedWrappedFieldProps>({
  explanationText,
  instructionText,
  label,
  input,
  inputComponent: Component,
  showArrow,
  ...props
}: P & {inputComponent?: React.ComponentType<Partial<P>>} & Pick<GridFormRowProp, 'showArrow'>) {
  return (
    <GridFormRow
      showArrow={showArrow}
      checked={!_.isEmpty(input.value)}
      left={
        <React.Fragment>
          <Typography variant="h6">{label}</Typography>
          <Typography variant="caption">{explanationText}</Typography>
        </React.Fragment>
      }
      right={Component ? <Component input={input} {...props as any} /> : null}
    />
  );
}

GridFormLabel.defaultProps = {
  showArrow: true,
};

export default GridFormLabel;
